import React from 'react'
import NavLink from '../Routes/NavLink'
import { userAccounts } from '../../core/controllers/UserAccounts'
import UserList from './UserList';

export default class UsersSelect extends React.Component {
    constructor(props) {
        super(props);

        var colSize = 2;
        var title = "Select a user";
        var sortID = 0;
        var disabled = "";
        var accountType = 'all';

        if(this.props.columnSize !== undefined)
        {
            colSize = this.props.columnSize;

        } if(this.props.title !== undefined)
        {
            title = this.props.title;
        } if(this.props.sortID !== undefined)
        {
            sortID = this.props.sortID;
        } if(this.props.accountType !== undefined) {
            accountType = this.props.accountType;
        }
        if(this.props.disabled !== undefined)
        {
            disabled = this.props.disabled
        }

        this.options = {
            columnSize: "col-sm-" + colSize,
            title: title,
            sortID: sortID,
            accountType: accountType,
            disabled: disabled
        }

        if (colSize == 0) {
            this.options.columnSize = '';
        }
    }

    componentDidMount() {
        var self = this;
        userAccounts.getUsersWithCriteria(this.options.accountType, function(response) {
            self.setState(response);
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if(nextProps.sortID === undefined) {
            this.options.sortID = nextProps.sortID;
        } else {
            this.options.sortID = nextProps.sortID;
        }
    }

    render(){
        // #  Implement functionality to have tenant select list auto select selectID passed in, if one does
        const usersList = this.state;
        const options = this.options;
        const accountType = this.options.accountType;

        return (
            <div>
                {accountType == "contractor" ? (
                <div class={options.columnSize} style={{paddingLeft: "0px"}}>
                    <select disabled={options.disabled} class="form-control" value={options.sortID} onChange={this.props.onChange}>
                        <option value="0">Select a user</option>
                        {usersList != null && Array.isArray(usersList.data) && (
                            usersList.data.map(function(account, index){
                                {/* TODO: Design this with a picture and line break between name and company */}
                                if (account.user_data.firstname || account.user_data.lastname) {
                                    if (account.user_data.company) {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user_data.firstname} {account.user_data.lastname} - {account.user_data.company}
                                        </option>
                                    } else {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user_data.firstname} {account.user_data.lastname}
                                        </option>
                                    }
                                } else {
                                    if (account.user_data.company) {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user.username} - {account.user_data.company}
                                        </option>
                                    } else {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user.username}
                                        </option>
                                    }
                                }
                            })
                        )
                        }
                    </select>
                </div>
                ) : (
                <div class={options.columnSize} style={{paddingLeft: "0px"}}>
                    <select disabled={options.disabled} class="form-control" value={options.sortID} onChange={this.props.onChange}>
                        <option value="0">Select a user</option>
                        {usersList != null && Array.isArray(usersList.data) && (
                            usersList.data.map(function(account, index){
                                if (account.user_data.firstname || account.user_data.lastname) {
                                    if (account.user_data.company) {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user_data.firstname} {account.user_data.lastname} - {account.user_data.company}
                                        </option>
                                    } else {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user_data.firstname} {account.user_data.lastname}
                                        </option>
                                    }
                                } else {
                                    if (account.user_data.company) {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user.username} - {account.user_data.company}
                                        </option>
                                    } else {
                                        return <option value={account.user.id} key={account.user.id}>
                                            {account.user.username}
                                        </option>
                                    }
                                }
                            })
                        )
                        }
                    </select>
                </div>  
                )}
            </div>
        )
    }
};


// WEBPACK FOOTER //
// app/components/Users/UsersSelect.jsx